<cc-sidebar
  [(inputIsVisible)]  = "inputIsVisible"
  (onHide)            = "processHideSidebar()"
  [inputTitle]        = "sidebarTitle">

  @if(isInImportMode())
  {
    <template-import-excel-report
      [$form]     = "$form"
      (onUpload)  = "processFile($event)">
    </template-import-excel-report>
  }

</cc-sidebar>
